module.exports = __webpack_public_path__ + "img/depaul.7ccafeff.jpeg";